import React from 'react';
import { Send, Search, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ProcessSection = () => {
  const { t } = useLanguage();

  return (
    <section id="fonctionnement" className="bg-[#1a1c1b] py-20 md:py-28 border-t border-[#3f4816]/30">
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="font-black text-[#d9fb06] text-3xl sm:text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.85]">
            {t.process.title}
          </h2>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection line - desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-px bg-[#3f4816] -translate-y-1/2 z-0" />
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative z-10">
            {t.process.steps.map((step, index) => (
              <div key={step.id} className="relative">
                {/* Step card */}
                <div className="bg-[#1a1c1b] border border-[#3f4816]/50 p-6 md:p-8 relative">
                  {/* Step number */}
                  <div className="absolute -top-5 left-6 md:left-8 bg-[#1a1c1b] px-3">
                    <span className="text-[#3f4816] font-black text-5xl md:text-6xl leading-none">
                      {step.step}
                    </span>
                  </div>

                  <div className="pt-6 md:pt-8">
                    {/* Icon */}
                    <div className="w-11 h-11 rounded-full border border-[#d9fb06]/30 flex items-center justify-center mb-5">
                      {index === 0 && <Send className="w-4 h-4 text-[#d9fb06]" />}
                      {index === 1 && <Search className="w-4 h-4 text-[#d9fb06]" />}
                      {index === 2 && <ArrowRight className="w-4 h-4 text-[#d9fb06]" />}
                    </div>

                    {/* Title */}
                    <h3 className="font-bold text-[#d9fb06] text-lg md:text-xl mb-3">
                      {step.title}
                    </h3>

                    {/* Description */}
                    <p className="text-[#888680] text-sm md:text-base leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Arrow indicator - mobile */}
                {index < t.process.steps.length - 1 && (
                  <div className="lg:hidden flex justify-center py-4">
                    <ArrowRight className="w-6 h-6 text-[#3f4816] rotate-90" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
